import { Grid } from "@mui/material";
import React from "react";
import CollectionGallery from "./CollectionGallery";
import "./collection.css";

function CollectionMain() {
  return (
    <div className="collection_main">
      <Grid container justifyContent="center">
        <Grid item xs={11} md={10} lg={10}>
          {/* Grid for upper */}
          <div className="upper_heading_col">
            <Grid container justifyContent="space-between" alignItems="center">
              <Grid item lg={6}>
                <h1 className="col_head">Artwork collections</h1>
              </Grid>
              <Grid item lg={2} className="center_flex">
                <button className="common_btn">apply filter</button>
              </Grid>
            </Grid>
          </div>

          {/* Grid for upper */}
          <CollectionGallery />
          <CollectionGallery />
          <CollectionGallery />
        </Grid>
      </Grid>
      <div className="seprator"></div>
      <div className="seprator"></div>
      <div className="seprator"></div>
    </div>
  );
}

export default CollectionMain;
